import { render } from "./ServicePointsSelector.vue?vue&type=template&id=f871714c"
import script from "./ServicePointsSelector.vue?vue&type=script&lang=js"
export * from "./ServicePointsSelector.vue?vue&type=script&lang=js"

import "./ServicePointsSelector.vue?vue&type=style&index=0&id=f871714c&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__